import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableHomepageQuickActions = () => useFeatureFlag(FeatureFlagDeclarations.enableHomepageQuickActions);
